import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect, Route, Switch } from 'react-router';

import { routes } from 'constants/routes';
import { dynamic } from 'helpers/makeLazy';
import { userFetch } from 'store/features';

import { AuthenticatedScene } from 'components/authenticated-scene';
import { AuthorizedScene } from 'components/authorized-scene';

import { Box } from 'components/@ux/box';

import { UserType } from './types/Auth';

const SignIn = dynamic(() => import('scenes/sign-in'));
const SignUp = dynamic(() => import('scenes/sign-up'));
const StartUp = dynamic(() => import('scenes/start-up'));
const Admin = dynamic(() => import('scenes/admin'));
const Docs = dynamic(() => import('scenes/docs'));

const StartUpRedirect = () => {
  const userType: UserType | undefined = useSelector(userFetch.selectors.getUserType);

  let redirectRoute = '<unknown route>';

  if (userType === 'USER') {
    redirectRoute = routes.docsAppRoute;
  }

  if (userType === 'ADMIN') {
    redirectRoute = routes.adminRoute;
  }

  return <StartUp redirectPath={redirectRoute} />;
};

const AutheticatedApp = () => {
  return (
    <Switch>
      <Route path={routes.startUpRoute} component={StartUpRedirect} />
      <AuthorizedScene path={routes.docsAppRoute} authorizedUsers={['USER']} component={Docs} />
      <AuthorizedScene path={routes.adminRoute} authorizedUsers={['ADMIN']} component={Admin} />
      <Route path="*" render={() => <Redirect to={routes.startUpRoute} />} />
    </Switch>
  );
};

export const App = (): JSX.Element => (
  <Box width="100vw">
    <Switch>
      <Route path={routes.signInRoute} component={SignIn} />
      <Route path={routes.signUpRoute} component={SignUp} />
      <AuthenticatedScene path="*" component={AutheticatedApp} />
    </Switch>
  </Box>
);
